export const PROMO_CODE = 'PROMO_CODE'
export const DEAL_CODE = 'DEAL_CODE'

export const SKIP_DEFAULT = 0
export const LIMIT_DEFAULT = 10

export const AUTH_SESSION = 'AUTH_SESSION'
